module.exports = __webpack_public_path__ + "img/2-1.6cd7b184.png";